"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUser = exports.UserContext = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importStar(require("react"));
var reduxHooks_1 = require("portal/hooks/reduxHooks");
exports.UserContext = (0, react_1.createContext)({
    loading: true,
    firebaseUser: undefined,
});
var useUser = function () { return (0, react_1.useContext)(exports.UserContext); };
exports.useUser = useUser;
function User(_a) {
    var children = _a.children;
    //   const [firebaseUser, loading] = useAuthState(auth);
    var _b = (0, reduxHooks_1.useAppSelector)(function (state) { return state.auth; }), status = _b.status, user = _b.user, error = _b.error, currentUser = _b.currentUser;
    return ((0, jsx_runtime_1.jsx)(exports.UserContext.Provider, __assign({ value: {
            loading: status == "loading",
            firebaseUser: currentUser,
        } }, { children: children })));
}
exports.default = User;
